<template>
  <div class="page">
    <div class="form">
      <div>
        <div class="cell-list">
          <div class="cell" @click="openPicker">
            <div class="label">
              不予受理原因
              <span style="font-family: PingFangSC-Regular;font-weight: 400;font-size: 14px;color: #F94F4E;">*</span>
            </div>
            <div class="content">
              <span :class="{'please-choose': reasonItem.name === '请选择'}">{{ reasonItem.name }}</span>
              <van-icon class="arrow" name="arrow" />
            </div>
          </div>
          <div v-if="reasonItem.id === 4" class="cell" @click="openReturnOrder">
            <div class="label">
              重复退货单
              <span style="font-family: PingFangSC-Regular;font-weight: 400;font-size: 14px;color: #F94F4E;">*</span>
            </div>
            <div class="content">
              <span>请选择</span>
              <van-icon class="arrow" name="arrow" />
            </div>
          </div>
          <div v-if="repeatOrderObj" class="order-item">
            <p class="title">{{ repeatOrderObj.product }}</p>
            <p class="info">企业名称：{{ repeatOrderObj.shoppingStore }}</p>
            <p class="info">退货人：{{ repeatOrderObj.purchaser }}</p>
            <p class="info">联系电话：{{ repeatOrderObj.submitUserTel }}</p>
            <p class="info">退货时间：{{ repeatOrderObj.creatTime | timeFilter }}</p>
            <p class="info">退货单号：{{ repeatOrderObj.orderNumber }}</p>
          </div>
        </div>
        <div class="Audit-opinion">
          <p class="title">
            补充说明
          </p>
          <van-field
            class="textarea"
            v-model="content"
            autosize
            type="textarea"
            placeholder="请输入"
            maxlength="500"
            show-word-limit
          />
          <!-- <textarea
            v-model="content"
            class="textarea"
            placeholder="请输入"
            cols="30"
            rows="10"
            maxlength="500"
          ></textarea> -->
          <!-- <div class="tip">{{ content.length }}/500</div> -->
        </div>
      </div>

      <div class="btn" @click="confirm" :class="{'btn-disable': reasonItem.name === '请选择' || !content}">确定</div>
    </div>
    <!-- 弹框 -->
    <list
      ref="picker"
      @select="selectItem"
      @close="selectItem"
      :datalist="dataList"
      :header="'选择不予受理原因'"
    />
    <!-- 重复退货单弹框 -->
    <van-popup
      class="returnOrder-pop"
      v-model="returnOrderShow"
      position="bottom"
      closeable
      :close-icon="close"
      :style="{ height: '70%' }"
    >
      <div class="body">
        <div class="header">选择需要关联的退货单</div>
        <van-search @search="onSearch" class="vant-search" v-model="keyWord" placeholder="退货单号/退货人姓名/电话/企业名" />
        <div v-if="repeatOrderlist && repeatOrderlist.length > 0" class="order-list">
          <div
            v-for="(item, index) in repeatOrderlist"
            @click="selectRepeatOrder(item, index)"
            :key="index"
            class="order-item"
          >
            <p class="title">{{ item.product }}</p>
            <p class="info">企业名称：{{ item.shoppingStore }}</p>
            <p class="info">退货人：{{ item.purchaser }}</p>
            <p class="info">联系电话：{{ item.submitUserTel }}</p>
            <p class="info">退货时间：{{ item.creatTime | timeFilter }}</p>
            <p class="info">退货单号：{{ item.orderNumber }}</p>
            <div v-if="repeatOrderIndex === index" class="circle-active">
              <p></p>
            </div>
            <div v-else class="circle"></div>
          </div>
        </div>
        <div v-else class="nodata">
          <img src="../../../../assets/refund/ic_wangluo(2).png" alt />
          <p class="p1">暂无数据</p>
          <p class="p2">请调整关键词进行尝试</p>
        </div>
      </div>
    </van-popup>
 
    <!-- 不予受理 -->
    <!-- <div class="container">
      <div class="item line_bottom">
        <div class="left">
          <span>退货单号</span>
          <span>{{orderNumber}}</span>
        </div>
        <span>></span>
      </div>
      <div class="item line_bottom" @click="showType">
        <div class="left">
          <span>原由</span>
          <span class="result_style" :class="{'choosed':choose}">{{typeValue}}</span>
        </div>
        <img src="../../../../assets/image/right.png" class="back" />
      </div>
      <div class="result">
        <span class="info">补充</span>
        <textarea class="content" placeholder="请输入不予受理补充内容..." v-model="content"></textarea>
      </div>
      <div class="btn" v-if="isOriginHei">
        <span @click="confirm" :class="{'active':change}">确认</span>
      </div>
      <common-picker ref="commonPicker" :typeList="typeList" :cols="cols1" @getTypeValue="getTypeValue"></common-picker>
    </div>-->
  </div>
</template>
<script>
    import util from '../../../../utils/common';
    import api from '../../../../service/modules/refund.js';
    import list from '../components/listPopup';
    import commonPicker from '../../../../components/base/commonPicker';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        components: {
            commonPicker,
            list
        },
        filters: {
            timeFilter (val) {
                return util.getStampInDate3(val);
            }
        },
        data () {
            return {
                keyWord: '',
                close: require('../../../../assets/refund/down.png'),
                returnOrderShow: false,
                reasonItem: {
                    name: '请选择'
                },
                repeatOrderIndex: '', // 选择的重复退货单的index
                repeatOrderlist: [], // 重复退货单列表
                repeatOrderObj: '', // 所选退货单
                dataList: [],
                // title: "不予受理",
                typeValue: '请选择原由',
                typeList: [],
                code: '',
                content: '',
                cols1: 1,
                choose: false,
                flowId: this.$router.currentRoute.query.flowId,
                orderNumber: this.$router.currentRoute.query.number,
                isOriginHei: true,
                documentHeight: document.documentElement.clientHeight, // 默认屏幕高度
                isFlag: true,
                orderDetail: {} // 退货单详情
            };
        },
        computed: {
            ...mapGetters('refund', ['getDictType']),
            change () {
                if ((this.code !== '') & (this.content.trim().length > 0)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        mounted () {
            window.onresize = () => {
                return (() => {
                    if (this.documentHeight > document.documentElement.clientHeight) {
                        this.isOriginHei = false;
                    } else {
                        this.isOriginHei = true;
                    }
                })();
            };
        },
        created () {
            try {
                this.orderDetail = this.$route.query.data;
                this.getFindRepeatOrder();
                // this.getType();
                this.setDictType().then(res => {
                    if (res.WHEREFORE) {
                        res.WHEREFORE.map(item => {
                            this.dataList.push({
                                name: item.name,
                                id: item.code
                            });
                        });
                    }
                });
            } catch (err) {
                console.log(err);
            }
        },
        methods: {
            ...mapActions('refund', ['setDictType']),
            selectItem (item) {
                this.reasonItem = item;
            },
            // 选择退货单回调
            selectRepeatOrder (item, index) {
                this.repeatOrderObj = item;
                this.repeatOrderIndex = index;
                this.returnOrderShow = false;
            },
            // 搜索退货单
            onSearch () {
                this.getFindRepeatOrder()
            },
            // 获取重复退货单
            getFindRepeatOrder (keyWord) {
                const param = {
                    tel: this.orderDetail.telephone,
                    basicId: this.orderDetail.basicId,
                    condition: this.keyWord
                };
                api.getFindRepeatOrder(param).then(res => {
                    if (res.ret === 0) {
                        this.repeatOrderlist = res.data;
                    } else {
                        this.repeatOrderlist = [];
                    }
                });
            },
            // 打开重复退货单弹框
            openReturnOrder () {
                this.returnOrderShow = true;
            },
            getType () {
                var type = util.getJsonLocal('configList').WHEREFORE;
                let list = [];
                type.map((item, index) => {
                    // list.push({ text: item.name, value: index, code: item.code });
                    list.push({ name: item.name, id: item.code });
                });
                this.typeList.push(list);
            },
            showType () {
                this.$refs.commonPicker.showPicker();
            },
            getTypeValue (value) {
                this.typeValue = value[0].text;
                this.code = value[0].code;
                this.choose = true;
            },
            openPicker () {
                this.$refs['picker'].init(this.reasonItem);
            },
            confirm () {
                if (this.reasonItem.name === '请选择') {
                    return this.$Toast({
                        message: '请选择不予受理原因'
                    });
                } else if (this.reasonItem.id === 4 && !this.repeatOrderObj) {
                    return this.$Toast({
                        message: '请选择重复退货单'
                    });
                } else {
                    this.getNotHandled();
                }
                // if (this.cols1 === "") {
                //   this.$Toast({
                //     message: "请选择退货原因"
                //   });
                // } else if (this.content.trim().length === 0) {
                //   this.$Toast({
                //     message: "请填写补充原因"
                //   });
                // } else {
                //   if (this.isFlag) {
                //     this.getNotHandled();
                //     this.isFlag = false;
                //   }
                // }
            },
            getNotHandled () {
                if (!this.content) {
                    return this.$Toast({
                        message: '请填写补充说明'
                    });
                }
                // 不予受理
                api
                    .notHandled({
                        flowId: this.flowId,
                        context: this.content,
                        wherefore: this.reasonItem.id,
                        repeatFlowId: this.repeatOrderObj ? this.repeatOrderObj.flowId : ''
                    })
                    .then(res => {
                        if (res.ret === 0) {
                            this.isOriginHei = false;
                            this.$Toast({
                                message: res.msg
                            });
                            setTimeout(() => {
                                this.$router.back();
                            }, 1500);
                        } else {
                            this.$Toast({
                                message: res.msg
                            });
                        }
                    });
            }
        }
    };
</script>
<style scoped  lang="less">
.page {
  .van-icon-arrow:before {
    font-size: 12px;
  }
  .form {
    padding: 0 16px 34px;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .cell-list {
      margin-bottom: 24px;
      .cell {
        padding: 20px 0;
        border-bottom: 1px solid #eeeeee;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .label {
          font-size: 14px;
          color: #666666;
          span {
            color: red;
            vertical-align: middle;
            margin-left: 2px;
          }
        }
        /deep/.content {
          display: flex;
          align-items: center;
          .van-field__control {
            text-align: right;
          }
          // .van-radio__label {
          //   font-size: 14px;
          //   color: #171a1d;
          // }
          // .van-radio__icon {
          //   display: flex;
          //   align-items: center;
          // }
          span {
            font-size: 14px;
            color: #171a1d;
          }
          .please-choose {
            color: #CCCCCC;
            font-weight: 400;
          }
          .arrow {
            font-size: 1px;
            color: #ababab;
            vertical-align: sub;
            margin-left: 5px;
          }
        }
      }
      .order-item {
        padding: 16px 16px 20px;
        background-color: #f7f7f7;
        border-radius: 4px;
        position: relative;
        margin-bottom: 12px;
        .title {
          font-size: 16px;
          color: #333333;
          font-weight: 400;
          margin-bottom: 10px;
        }
        .info {
          font-size: 12px;
          color: #999999;
          &:not(:last-child) {
            margin-bottom: 6px;
          }
        }
      }
    }
    .Audit-opinion {
      position: relative;
      .title {
        font-size: 14px;
        color: #666666;
        margin-bottom: 12px;
        margin-top: 20px;
        &::after {
          content: '*';
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #F94F4E;
        }
      }
      /deep/.textarea {
        width: 100%;
        // height: 160px;
        background: #f8f9fb;
        padding: 16px 4px 16px 16px;
        border-radius: 4px 4px 0 0;
        border: 0;
        font-size: 14px;
        line-height: 20px;
        box-sizing: border-box;
        .van-field__control {
          min-height: 100px;
          max-height: 340px;
        }
        .van-field__control::-webkit-scrollbar {
              width: 3px;
          }
          .van-field__control::-webkit-scrollbar-thumb {
              background: #E4E5E8;
          }
          .van-field__control::-webkit-scrollbar-track {
              background: #F8F9FB;
          }
      }
      .tip {
        text-align: right;
        padding-right: 16px;
        background: #f8f9fb;
        width: 100%;
        position: relative;
        top: -15px;
        font-size: 14px;
        color: #cccccc;
        border-radius: 0 0 4px 4px;
        line-height: 25px;
      }
    }
  }
    .btn {
      margin-top: 20px;
      background-color: #37b375;
      text-align: center;
      font-size: 16px;
      color: #ffffff;
      line-height: 48px;
      border-radius: 4px;
    }
    .btn-disable {
      background-color: #9bd9ba;
    }
  .returnOrder-pop {
    .body {
      padding: 0 16px;
      .header {
        padding-top: 20px;
        margin-bottom: 14px;
        font-size: 16px;
        color: #171a1d;
        font-weight: 600;
      }
      .vant-search {
        padding: 0;
        margin-bottom: 20px;
      }
      .order-list {
        max-height: 464px;
        overflow-y: auto;
        .order-item {
          padding: 16px 16px 20px;
          background-color: #f7f7f7;
          border-radius: 4px;
          position: relative;
          margin-bottom: 12px;
          .circle {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            border: 1px solid #a3a4a7;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 16px;
          }
          .circle-active {
            width: 18px;
            height: 18px;
            padding: 3px;
            border-radius: 50%;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 16px;
            border: 1px solid #36b374;
            p {
              border-radius: 50%;
              background-color: #36b374;
              width: 100%;
              height: 100%;
            }
          }
          .title {
            font-size: 16px;
            color: #333333;
            font-weight: 400;
            margin-bottom: 10px;
          }
          .info {
            font-size: 12px;
            color: #999999;
            &:not(:last-child) {
              margin-bottom: 6px;
            }
          }
        }
      }
      .nodata {
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 88px;
          height: 88px;
          margin-bottom: 18px;
          margin-top: 110px;
        }
        .p1 {
          font-size: 16px;
          color: #666666;
          font-weight: 400;
          margin-bottom: 11px;
        }
        .p2 {
          font-size: 12px;
          color: #999999;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
